import { useState, useEffect } from 'react';
import { onConnectionChange, getConnectionStatus } from '@/utils/apiResilience';
import { WifiOff, Wifi } from 'lucide-react';

const ConnectionStatus = () => {
  const [online, setOnline] = useState(getConnectionStatus());
  const [showReconnected, setShowReconnected] = useState(false);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const unsub = onConnectionChange((isOnline) => {
      setOnline(isOnline);
      if (!isOnline) {
        setWasOffline(true);
      }
      if (isOnline && wasOffline) {
        setShowReconnected(true);
        setTimeout(() => setShowReconnected(false), 3000);
        setWasOffline(false);
      }
    });
    return unsub;
  }, [wasOffline]);

  if (online && !showReconnected) return null;

  return (
    <div
      data-testid="connection-status"
      className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] px-4 py-2.5 rounded-lg shadow-lg flex items-center gap-2 text-sm font-medium transition-all duration-300 ${
        online
          ? 'bg-green-600 text-white'
          : 'bg-red-600 text-white animate-pulse'
      }`}
    >
      {online ? (
        <>
          <Wifi className="w-4 h-4" />
          <span dir="auto">تم استعادة الاتصال</span>
        </>
      ) : (
        <>
          <WifiOff className="w-4 h-4" />
          <span dir="auto">لا يوجد اتصال بالإنترنت</span>
        </>
      )}
    </div>
  );
};

export default ConnectionStatus;
